export default __webpack_public_path__ + "static/media/logout-variant.859b4ddc.svg";